import verificationShield from "../../assets/verification.webp";
import matchingImage from "../../assets/matching.webp";
import payoutImage from "../../assets/payout.webp";

const steps = [
  {
    number: "01",
    title: "Verify",
    description: "Checks run the moment a lead is submitted.",
    image: verificationShield,
  },
  {
    number: "02",
    title: "Match",
    description:
      "In-house funding where it fits, partner NBFC or bank where it does not.",
    image: matchingImage,
  },
  {
    number: "03",
    title: "Payout",
    description:
      "Commission tracked from disbursal to bank transfer.",
    image: payoutImage,
  },
];

function Process() {
  return (
    <section className="overflow-hidden  py-10 sm:py-12 lg:py-14">
      <div className="section-container">

        {/* Section Label */}
        <p className="font-jakarta text-[12px] font-semibold tracking-[0.34em] text-[var(--mint-green)] sm:text-[13px]">
          THE PROCESS
        </p>

        {/* =====================================================
            DESKTOP (Compact & Tightly Aligned Height)
        ====================================================== */}
        <div className="relative mt-6 hidden h-[320px] lg:block">

          {/* ===================================================
              CURVED ANIMATED LINE
          ==================================================== */}
          <svg
            className="pointer-events-none absolute inset-0 z-0 h-full w-full"
            viewBox="0 0 1435 320"
            preserveAspectRatio="none"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="
                M 132 75
                C 300 50, 425 60, 575 75
                C 720 90, 850 100, 1010 105
                C 1160 110, 1280 105, 1375 85
              "
              pathLength="1"
              stroke="#8BEBCB"
              strokeWidth="2.8"
              strokeDasharray="0.018 0.018"
              strokeLinecap="round"
              className="process-flow-line"
            />
          </svg>

          {/* ===================================================
              STEP 01 — VERIFY
          ==================================================== */}
          <article className="absolute left-0 top-0 z-10 w-[360px]">
            {/* Image */}
            <div className="flex h-[88px] items-start">
              <img
                src={verificationShield}
                alt=""
                className="w-[70px] object-contain"
                loading="lazy"
                decoding="async"
              />
            </div>

            {/* Number */}
            <p className="mt-1 font-jakarta text-[13px] font-bold text-[var(--mint-green)]">
              01
            </p>

            {/* Title */}
            <h2 className="mt-1 font-bricolage text-[25px] font-bold leading-[1.08] tracking-[-0.7px] text-[#0b1720]">
              Verify
            </h2>

            {/* Description */}
            <p className="mt-2.5 font-jakarta text-[15px] leading-[1.6] text-[#46545d]">
              Checks run the moment a lead is submitted.
            </p>
          </article>

          {/* ===================================================
              STEP 02 — MATCH
          ==================================================== */}
          <article className="absolute left-[38%] top-[55px] z-10 w-[360px]">
            {/* Image */}
            <div className="flex h-[88px] items-start">
              <img
                src={matchingImage}
                alt=""
                className="w-[66px] object-contain"
                loading="lazy"
                decoding="async"
              />
            </div>

            {/* Number */}
            <p className="mt-1 font-jakarta text-[13px] font-bold text-[var(--mint-green)]">
              02
            </p>

            {/* Title */}
            <h2 className="mt-1 font-bricolage text-[25px] font-bold leading-[1.08] tracking-[-0.7px] text-[#0b1720]">
              Match
            </h2>

            {/* Description */}
            <p className="mt-2.5 font-jakarta text-[15px] leading-[1.6] text-[#46545d]">
              In-house funding where it fits, partner NBFC or bank where it does not.
            </p>
          </article>

          {/* ===================================================
              STEP 03 — PAYOUT
          ==================================================== */}
          <article className="absolute right-0 top-[20px] z-10 w-[360px]">
            {/* Image */}
            <div className="flex h-[88px] items-start">
              <img
                src={payoutImage}
                alt=""
                className="w-[66px] object-contain"
                loading="lazy"
                decoding="async"
              />
            </div>

            {/* Number */}
            <p className="mt-1 font-jakarta text-[13px] font-bold text-[var(--mint-green)]">
              03
            </p>

            {/* Title */}
            <h2 className="mt-1 font-bricolage text-[25px] font-bold leading-[1.08] tracking-[-0.7px] text-[#0b1720]">
              Payout
            </h2>

            {/* Description */}
            <p className="mt-2.5 font-jakarta text-[15px] leading-[1.6] text-[#46545d]">
              Commission tracked from disbursal to bank transfer.
            </p>
          </article>
        </div>

        {/* =====================================================
            MOBILE (Compact & Clean)
        ====================================================== */}
        <div className="mt-8 space-y-7 lg:hidden">
          {steps.map((step, index) => (
            <article
              key={step.number}
              className={`flex gap-5 sm:gap-6 ${
                index !== steps.length - 1
                  ? "border-b border-[#dfe7e3] pb-7"
                  : ""
              }`}
            >
              {/* Image */}
              <div className="flex w-[65px] shrink-0 items-start justify-center sm:w-[75px]">
                <img
                  src={step.image}
                  alt=""
                  className={`object-contain ${
                    index === 0
                      ? "w-[60px] sm:w-[66px]"
                      : "w-[56px] sm:w-[62px]"
                  }`}
                  loading="lazy"
                  decoding="async"
                />
              </div>

              {/* Content */}
              <div className="min-w-0 pt-0.5">
                <p className="font-jakarta text-[12px] font-bold text-[var(--mint-green)]">
                  {step.number}
                </p>

                <h2 className="mt-0.5 font-bricolage text-[24px] font-bold leading-[1.1] tracking-[-0.6px] text-[#0b1720] sm:text-[26px]">
                  {step.title}
                </h2>

                <p className="mt-2 font-jakarta text-[14px] leading-[1.6] text-[#46545d]">
                  {step.description}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>

      {/* =======================================================
          LINE ANIMATION
      ======================================================== */}
      <style>{`
        .process-flow-line {
          animation: processFlow 4s linear infinite;
        }

        @keyframes processFlow {
          from {
            stroke-dashoffset: 0;
          }

          to {
            stroke-dashoffset: -0.108;
          }
        }

        @media (prefers-reduced-motion: reduce) {
          .process-flow-line {
            animation: none;
          }
        }
      `}</style>
    </section>
  );
}

export default Process;